import axios from 'axios'
import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'
import qs from 'qs'
import Vue from 'vue'

import Vant from 'vant'

import { Toast } from 'vant';

Vue.use(Toast);


import router from '@/router/index'
import Cookie from './globalData'

let public_key =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDbctiVJ04Y8XAE/vRbn0Y/bZsg' +
  'qeaUntDHsR0zAmDjnoLlWME6W0oX1jkkDyUc3FyBSDMiKcKYufA6WUiRo36sgU+Z' +
  'LEZcMv66nikqfC7bynu9KcT8ZavhWu7MyJyIn280GC74bi4O5lyHNF4//0OZZQRm' +
  'a23NeA7kwkJBajKs1QIDAQAB'

let lock = 'zhelishimima1111'
let rsaEncodelisy = rsaEncode(lock)

// axios 响应拦截器
axios.interceptors.response.use(
  response => {
    // console.log(response);

    // 如果没有开通协议，默认重定向到 => 开通页面 (/open)
    // if (response.data.status == -10006 || response.data.status == '-10006') {
    //   router.push({
    //     path: '/open'
    //   })
    // }

    return response
  },
  error => {
    return Promise.reject(error)
  }
)

// 封装axios请求
class Http {
	
  constructor(el) {
    this.el = el
    this.Domain ='http://'+document.domain+'/api/';  // 正式
    // console.log(this.Domain)
    this.Domain = 'https://interface.daominyoupin.com/api/' // 正式接口
    // this.Domain = 'https://ttoker.7dingdong.com/api/' // 测试接口
  }
  require(options) {
    Toast.loading({
	    message: '加载中...',
	    forbidClick: true,
	  });
    let box_token = Cookie.getCookie('SYB_TX[tokenId]')
    if (!options.api) throw new Error('api 不能为空')
    if (!options.param) {
      options.param = {}
    } //param==空  默认赋值一下
    if (!options.methods) {
      options.methods = 'POST'
    } //不传递方法默认为POST
    let timer = Date.parse(new Date()) / 1000 //时间戳 以秒为单位
    let ControllerStr = options.api.replace(/[/]/g, '')

    var params = {
      content: {
        base: {
          time: timer,
          source: 6,
          equipment: 'b2bwap',
          // token: '0065d13a6f2bd413a3ceb34421b40711', //box_token||'A0EE1016E598FAC8D3E7626C823DAC38
          version: options.param.version
            ? options.param.version
            : this.el.version
              ? this.el.version
              : 'v1.0',
          // version: this.el.version ? this.el.version : 'v2.0'
          token:localStorage.getItem('token'), 
          // token:'bc9037d74818e7d0e99b41600b142508' //正式 c可可可可
         
          // token:'8ef8113ca11d211aebc4d6004409e5d0' //测试  c 可用
        },
        data: {
          method: options.api
        }
      },
      time: timer,
      app_key: 'GztY827iLd5EkQqbMDzfPq41Kf5QV0Ff'
    }
    //    lock:rsaEncodelisy,
    for (let itm in options.param) {
      params.content.data[itm] = options.param[itm]
    }

    if (params.lock) {
      params.content = aesEncrypt(JSON.stringify(params.content))
    }
    let pee = qs.stringify(params)
 
    return new Promise((resolve, reject) => {
      return axios({
        method: options.methods, //get post
        url: '', // url
        baseURL: this.Domain, // 请求地址
        data: pee, //请求数据
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
        .then(
          response => {
			  Toast.clear();
            if (response.data.lock) {
              response.data.content = JSON.parse(
                aesDecrypt(response.data.content, decrypt(response.data.lock))
              )
            }
           
            if (response.data.status == '-10003') {
              //处理课程兑换码扫码-未登录状态
              var kc_urlnamejson=window.location.href.split('#')[1]
              var authUrlName=kc_urlnamejson.split('?')[0] //课程兑换码扫码路径获取
              
              let url = authUrlName=='/c_scancode'?encodeURIComponent(`/#${kc_urlnamejson}`):encodeURIComponent('/#/user/index')
              
              console.log(url,'=2222',encodeURIComponent(`/#${kc_urlnamejson}`))
               // 正式授权
              window.location.replace(
                `https://auth.daominyoupin.com/wap/H5/index.html?_from=vue&backUrl=${url}`
              ) 
             
              // Toast('登录失效,重新登录~');
     
               // 测试授权
              // window.location.replace(`https://ttoker.7dingdong.com/wap/H5/index.html?_from=vue&backUrl=${url}`)

            }
            if (response.data.status == '-10006') { // b 登录失效
              Toast('登录失效,请重新登录');

            }
            resolve(response.data)

          },
          error => {
            reject(error)
          }
        )
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default Http
var secret = 'zhelishimima1111' //密码加密 16位
var iv = '106d46f29f9ea389' //偏移量 16位

function rsaEncode(str) {
  var encrypt = new JSEncrypt()
  encrypt.setPublicKey(public_key)
  var data = encrypt.encrypt(str)
  //console.log("RSA加密串 ：",data);
  return data
}
var private_key =
  'MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBAJrkvzZcK1kaQSfI' +
  'EtdpfgxrsH19zV3xLOdFLQbRdXxRvlzB75RGWMds05QPe2oU36yW2DNRpIrmBb4p' +
  'lBJy+X9rfDOy3Ar5QuVxD1pMlrEmLi2HLgUp10g8bNRtZTvMNmO/CGzhZatgRV36' +
  'lBjI8B7pT2o4vUdPa+8GLbuQfI27AgMBAAECgYAZM5Sk3JQ0+B+XwGbIY6KdlLvv' +
  'fxN18HKU4l10GYpbAtXNM8SuRE/Xiq5WDbrPxLur0hM1LlhuPQS8LvmnkstjHiPJ' +
  'XIidRLRlxCkbtRxFiBlzn3YiNKLA1Hs9AXod2T65AlpK/lTb/YAp1w/R8HaYoKlb' +
  'UUkobGrHXO2K5r0lKQJBAMq3qSITA1QvAfJnxwbbrfEnt5u1x7IcoNg94uko05yK' +
  'liJAwEFyjR9eeDhCwibO2Ia46Vt6JdRLvlDFFv6Qs9UCQQDDmyOWI8MFhuB69dhp' +
  'MPMc2W2E3UA1za5lZ/mvqfkLF8Medx5J9KWgnoEikzFp6e8JchVXBUrhotk0oXl3' +
  '61NPAkBLGJqJSu3Sw88+038BZWQckBAOmNqvereDI/npUfyCYzyW19Hg7OSmmEKE' +
  '5QYzhjDkR5/7CVb2PFD2buzDxSs5AkAu5eZdXAupKpJtyL3vUpYnZ5YTkfyQKdVT' +
  'aN97l5QnbbYRetvfPXHslbQ+du4VB8qRCDJHn/Q5LxNGxCRcdSaPAkA8GMZGLSBk' +
  'EtSoyWe9l/K0PiPqbsEukWrjvlLGhLmoJkehPRzQO+26yeJsiSZ6amEMX09PcTAh' +
  '02tZUKk4HFej'

function aesEncrypt(content) {
  var key = CryptoJS.enc.Utf8.parse(secret) //
  var encryptResult = CryptoJS.AES.encrypt(content, key, {
    iv: CryptoJS.enc.Utf8.parse(iv),
    mode: CryptoJS.mode.CBC, //aes加密模式cbc
    padding: CryptoJS.pad.Pkcs7 //填充
  })
  var result = String(encryptResult) //把object转化为string
  return result
}

function aesDecrypt(content, secret) {
  var key = CryptoJS.enc.Utf8.parse(secret)
  var bytes = CryptoJS.AES.decrypt(content.toString(), key, {
    iv: CryptoJS.enc.Utf8.parse(iv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  var decryptResult = bytes.toString(CryptoJS.enc.Utf8)
  return decryptResult
}
function rsaDecode(str, dataList) {
  var encrypt = new JSEncrypt()
  encrypt.setPrivateKey(str)
  var data = encrypt.decrypt(dataList)

  //console.log("RSA解密串 ："+dd);
  return data
}

function decrypt(rsaDta) {
  let decryptor = new JSEncrypt() // 新建JSEncrypt对象
  decryptor.setPrivateKey(private_key) // 设置私钥
  const data = decryptor.decrypt(rsaDta) // 进行解密
  //   console.log(data)
  return data
}
